import {
  compose,
  pipe,
} from 'ramda'
import {
  componentDidMount,
  componentWillUnmount,
} from '../../../components/Lifecycles'
import {
  fetchTopArticles,
  cleanTopArticles,
} from '../../../store/modules/homepage'
import View from './TopArticles'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
  items: state.homepage.topArticles.list,
  isFetching: state.homepage.topArticles.isFetching,
})

const mapDispatchToProps = dispatch => ({
  fetchTopArticles: compose(dispatch, fetchTopArticles),
  cleanTopArticles: compose(dispatch, cleanTopArticles),
})

// didMount :: Props -> Action FETCH_TOP_ARTICLES
const didMount = ({ fetchTopArticles }) => fetchTopArticles()

// willUnmount :: Props -> Action CLEAN_TOP_ARTICLES
const willUnmount = ({ cleanTopArticles }) => cleanTopArticles()

// lifecycles :: React.Component -> React.Component
const lifecycles = pipe(
  componentDidMount(didMount),
  componentWillUnmount(willUnmount),
)(View)

const TopArticles = connect(
  mapStateToProps,
  mapDispatchToProps,
)(lifecycles)

export default TopArticles
